export const getVideoDurationSeconds = (registrant) => {
    if (typeof registrant?.videoDuration === 'string' && !registrant.videoDuration.trim()) return null;
    const seconds = Number(registrant?.videoDuration);
    return Number.isFinite(seconds) && seconds >= 0 && registrant?.videoDuration !== null && registrant?.videoDuration !== undefined
        ? Math.floor(seconds)
        : null;
};

export const formatDuration = (seconds) => {
    if (seconds === null || seconds === undefined) return 'Unknown';
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return hours > 0
        ? `${hours}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
        : `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
};

export const getSessionDurationSeconds = (timeRange) => {
    const match = /^(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})$/.exec(timeRange || '');
    if (!match) return null;
    const [, startHour, startMinute, endHour, endMinute] = match.map(Number);
    if (startHour > 23 || endHour > 23 || startMinute > 59 || endMinute > 59) return null;
    const difference = (endHour * 60 + endMinute) - (startHour * 60 + startMinute);
    return difference > 0 ? difference * 60 : null;
};

export const getAssignedVideoTotal = (registrants) => registrants.reduce((total, registrant) =>
    total + (getVideoDurationSeconds(registrant) || 0), 0);
